import enUS from './en-US.json';
import esES from './es-ES.json';
import frFR from './fr-FR.json';
import jaJP from './ja-JP.json';
import ptPT from './pt-PT.json';
import ruRU from './ru-RU.json';
import zhCN from './zh-CN.json';
export default {
    'en-US': enUS,
    'es-ES': esES,
    'fr-FR': frFR,
    'ja-JP': jaJP,
    'pt-PT': ptPT,
    'ru-RU': ruRU,
    'zh-CN': zhCN,
};
